import React, { useState, useEffect } from 'react'
import { Container } from 'react-bootstrap'
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import '../assets/css/gallery-page.css';
import activitiesData from '../assets/data/activities.json';


// Helper function to create gallery items from activity data
const createGalleryItems = (activities, category) => {
    const items = [];
    activities.forEach(activity => {
        if (activity.images && activity.images.length > 0) {
            activity.images.forEach((img, index) => {
                items.push({
                    img: img,
                    title: index === 0 ? activity.title : `${activity.title} - ${index + 1}`,
                    category: category,
                    location: activity.location,
                    date: activity.date
                });
            });
        }
    });
    return items;
};


// Create gallery data by combining all activities
const galleryData = [
    // Add all images from JSON activities
    ...createGalleryItems(activitiesData.self_reliance_activities, 'Self Reliance'),
    ...createGalleryItems(activitiesData.health_activities, 'Healthcare'),
    ...createGalleryItems(activitiesData.education_activities, 'Education'),
    ...createGalleryItems(activitiesData.donation, 'Community Support'),
    ...createGalleryItems(activitiesData.social_activity, 'Community Events')
];

const Gallery = () => {
    const location = useLocation();
    const pathname = location.pathname
    const hash = location.hash
    const key = location.key

    const [selectedCategory, setSelectedCategory] = useState('All');
    const [filteredImages, setFilteredImages] = useState(galleryData);
    const [selectedImage, setSelectedImage] = useState(null);

    useEffect(() => {
        // if not a hash link, scroll to top
        if (hash === '') {
            document.getElementById("body").scrollTo(0, 0);
        }
        // else scroll to id
        else {
            setTimeout(() => {
                const id = hash.replace('#', '');
                const element = document.getElementById(id);
                if (element) {
                    element.scrollIntoView();
                }
            }, 0);
        }
    }, [pathname, hash, key]);

    useEffect(() => {
        // Initialize with all images
        setFilteredImages(galleryData);
    }, []);

    const categories = ['All', ...new Set(galleryData.map(item => item.category))];

    const handleCategoryChange = (category) => {
        setSelectedCategory(category);
        if (category === 'All') {
            setFilteredImages(galleryData);
        } else {
            setFilteredImages(galleryData.filter(item => item.category === category));
        }
    };

    const openLightbox = (image) => {
        setSelectedImage(image);
        document.body.style.overflow = 'hidden';
    };

    const closeLightbox = () => {
        setSelectedImage(null);
        document.body.style.overflow = 'auto';
    };

    return (
        <div className='bg-accent'>
            {/* Breadcrumb Section */}
            <section id='donation-breadcrumb'>
                <Container>
                    <div className='donation-breadcrumb'>
                        <nav aria-label="breadcrumb">
                            <h3 className='breadcrumb-heading'>Gallery</h3>
                            <ol className="breadcrumb">
                                {/* <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Gallery</li> */}
                            </ol>
                        </nav>
                    </div>
                </Container>
            </section>

            {/* Gallery Info Section */}
            <section id='gallery'>
                <div className='centertext pt-5 pb-3'>
                    <h2 className=''>Our Journey in Pictures</h2>
                </div>
                <div className='gallery-info-content'>
                    Seva Sadhana Kutch has been serving the community for years, bringing hope and support to those in need.
                    <br />
                    Explore our gallery to witness the impact of our various initiatives across Kutch region.
                    <br />
                    From tiffin services to housing projects, every image tells a story of compassion and service.
                </div>
            </section>

            {/* Auto-Scroll Gallery Section */}
            <section id='gallery'>
                <Container fluid className='px-0'>
                    <div className='section-title-wrapper pt-5'>
                        <h2 className='text-center'>Featured Moments</h2>
                    </div>
                    <div className="gallery-scroll-wrapper">
                        <div className="gallery-track">
                            {[...galleryData, ...galleryData, ...galleryData].map((item, index) => (
                                <div
                                    key={`scroll-${index}`}
                                    className="gallery-scroll-item"
                                    onClick={() => openLightbox(item)}
                                >
                                    <img src={item.img} alt={item.title} loading="lazy" />
                                    <div className="gallery-scroll-overlay">
                                        <span className="gallery-scroll-title">{item.title}</span>
                                        <span className="gallery-scroll-category">{item.category}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </Container>
                <Container className='gallery-filter-container'>
                    <div className='section-title-wrapper pt-5'>
                        <h2 className='text-center'>Explore Our Work</h2>
                    </div>

                    {/* Category Filter */}
                    <div className='gallery-filter-buttons'>
                        {categories.map((category) => (
                            <button
                                key={category}
                                className={`filter-btn ${selectedCategory === category ? 'active' : ''}`}
                                onClick={() => handleCategoryChange(category)}
                            >
                                {category}
                            </button>
                        ))}
                    </div>

                    {/* Gallery Grid */}
                    <div className='gallery-grid pb-5'>
                        {filteredImages.map((item, index) => (
                            <div
                                key={index}
                                className='gallery-grid-item'
                                onClick={() => openLightbox(item)}
                            >
                                <img src={item.img} alt={item.title} loading="lazy" />
                                <div className='gallery-grid-overlay'>
                                    <h5>{item.title}</h5>
                                    <p>{item.category}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </Container>
            </section>

            {/* Lightbox Modal */}
            {selectedImage && (
                <div className='lightbox-modal' onClick={closeLightbox}>
                    <button className='lightbox-close' onClick={closeLightbox}>
                        ×
                    </button>
                    <div className='lightbox-content' onClick={(e) => e.stopPropagation()}>
                        <img src={selectedImage.img} alt={selectedImage.title} />
                        <div className='lightbox-info'>
                            <h4>{selectedImage.title}</h4>
                            <p>{selectedImage.category}</p>
                            {selectedImage.location && <p className='text-sm'>{selectedImage.location}</p>}
                            {selectedImage.date && <p className='text-sm'>{selectedImage.date}</p>}
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Gallery;